import React from 'react';
import { Title, Subtitle, StepText, HowToInstall } from './install.styled';
import { VSpace } from '../../../chat/settings/account/account-settings';
// import { SafariAddToHome } from './safari-add-to-home/safari-add-to-home';
import { motion } from 'framer-motion';

const iosSteps = [
  {
    label: 'Open in Safari',
    text: <>Tap the Share icon <img src="./share-icon-install-small.svg" alt="Share Icon"  /> on your screen</>,
  },
  {
    label: 'Add to Home Screen',
    text: <>Scroll to and then tap <b>Add to Home Screen</b></>,
  },
  {
    label: 'Confirm',
    text: <>Tap <b>Add</b> in the upper right</>,
  },
  {
    label: 'Open the App',
    text: <>Open Mailander from your Home Screen</>,
  },
];

const containerVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.25,
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
};

const stepVariants = {
  hidden: { opacity: 0, y: -8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2 },
  },
};

export const InstallAppIosSection: React.FC = () => {
  return (
    // <div className="display: flex; flex-direction: column; align-items: center; justify-content: space-between; height: 100%;">
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <div>
        <Title>Install Mailander.</Title>

        <VSpace $h={24} />

        <Subtitle>
          Access Mailander directly from
          <br />
          your Home Screen.
        </Subtitle>
      </div>
      <div style={{ width: '100%' }}>
        {/* share-icon-install.svg */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'Center', marginTop: "56px", marginBottom: "48px" }}>

        <img
          src="./share-icon-install.svg"
          alt="Share Icon"
          style={{ width: 34, height: 45}}
          />
          </div>
        <VSpace $h={24} />

        <motion.div
          key="ios-steps-container"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: '#23252A',
            border: '1px solid #2B2D33',
            borderRadius: '12px',
            paddingLeft: '16px',
            marginTop: 0,
          }}
        >
          <div>
            <VSpace $h={16} />
            <HowToInstall>How to install on iPhone</HowToInstall>
            <VSpace $h={12} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {iosSteps.map((step, index) => (
                <motion.div key={index} variants={stepVariants} style={{ overflow: 'hidden' }}>
                  <StepText>{step.text}</StepText>
                </motion.div>
              ))}
            </div>

            <VSpace $h={16} />
          </div>
        </motion.div>
      </div>
    </div>
  );
};
